import createIcon from '../../createIcon';

/**
 * @component @name FormatIndentIncrease
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAyMUgyMVYxOUgzVjIxWk0zIDhWMTZMNyAxMkwzIDhaTTExIDE3SDIxVjE1SDExVjE3Wk0zIDNWNUgyMVYzSDNaTTExIDlIMjFWN0gxMVY5Wk0xMSAxM0gyMVYxMUgxMVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatIndentIncrease = createIcon('FormatIndentIncrease', [
  [
    'path',
    {
      d: 'M3 21H21V19H3V21ZM3 8V16L7 12L3 8ZM11 17H21V15H11V17ZM3 3V5H21V3H3ZM11 9H21V7H11V9ZM11 13H21V11H11V13Z',
      key: 'bnniz0',
    },
  ],
]);

export default FormatIndentIncrease;
